import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import { funAcortarText } from "../../../../../global/utils/text";
import TildeOk from "../../../../assets/images/generico/TildeOk";
import { BodyCardCheck, ContainerCardCheck, TopCardCheck } from "./localStyle";

const CardCheck = ({
  title,
  horario,
  medico,
  sede,
  actived,
  flgSoloConsulta,
  setSelected,
}) => {
  const [active, setActive] = useState(actived);
  const handleClick = () => {
    // setActive(!active);
    setSelected(!active);
  };

  // Te dice si es AM O PM
  const funAMOrPM = (hora) => {
    hora = hora.slice(0, 2);
    hora = Number(hora);
    if (hora > 12) return "PM";
    else return "AM";
  };

  useEffect(() => {
    setActive(actived);
  }, [actived]);

  return (
    <ContainerCardCheck
      $active={active}
      onClick={handleClick}
      $flgSoloConsulta={flgSoloConsulta}
    >
      <TopCardCheck $active={active}>
        <div className="circle-orange">
          <TildeOk color={"var(--color-white)"} />
        </div>
        <h1>{funAcortarText(25, title)}</h1>
      </TopCardCheck>
      <BodyCardCheck>
        <p className="rb18b">
          Horario:{" "}
          <span className="rb18l">{`${horario} ${funAMOrPM(horario)}`}</span>
        </p>
        <p className="rb18b">
          Sede: <span className="rb18l">{funAcortarText(25, sede)}</span>
        </p>
        {flgSoloConsulta ? (
          <p className="rb18b">
            Especialista:{" "}
            <span className="rb18l">
              {funAcortarText(25, camelize(medico))}
            </span>
          </p>
        ) : (
          ""
        )}
      </BodyCardCheck>
    </ContainerCardCheck>
  );
};

export default CardCheck;
